import { ModalContext } from 'app/app';
import axios from 'axios';
import { IconedButton } from 'components/IconedButton';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  Grid,
  Icon,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './styles.module.scss';

export function Drivers(props) {
  const { id: company_id } = useParams();
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const { setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  const format = new DateUtils();

  async function runAPI(page, search) {
    setLoading(true);

    await axios
      .get(
        `/api/driver?page=${page}&search=${search}&company_id=${company_id}&active=true`
      )
      .then((res) => {
        setLoading(false);
        setPayload(res.data.data);

        var tempData = [];

        res.data.data.data.map((value, index) => {
          tempData.push({
            id: value.id,
            name: value.name,
            'DL Number': value.license_number,
            State: value.license_state,
            'Date of Birth': value.date_of_birth
              ? format.isoDate(value.date_of_birth)
              : '',
            'Date of Hire': value.date_of_hire
              ? format.isoDate(value.date_of_hire)
              : '',
            accidents: value.accidents ? value.accidents : '',
            exclude_from_policy: value.exclude_from_policy
              ? value.exclude_from_policy
              : false,
            violations: value.violations ? value.violations : '',
            suspensions: value.suspensions ? value.suspensions : '',
            'Years of Experience': value.years_of_experience,
            front_license_link: value.back_license,
            'Front DL': value.front_license ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  cursor: 'pointer',
                }}
                onClick={() => window.open(value.front_license)}
              >
                <Icon image={'image'} />
              </div>
            ) : (
              ''
            ),
            back_license_link: value.back_license,
            'Back DL': value.back_license ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  cursor: 'pointer',
                }}
                onClick={() => window.open(value.back_license)}
              >
                <Icon image={'image'} />
              </div>
            ) : (
              ''
            ),
            status: value.status,
          });
        });

        setData(tempData);
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);

        context.notification.show(
          'Failed to load table data',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  async function archiveDriver(id) {
    await axios
      .patch(`/api/driver/${id}`, {
        active: false,
        status: 'inactive',
      })
      .then((res) => {
        setLoading(false);

        runAPI(page, searchQueryString);

        context.notification.show(
          'Driver arquived!',
          'success',
          true,
          'toast',
          'check-circle'
        );
      })
      .catch((err) => {
        setLoading(false);

        context.notification.show(
          'Failed to arquive driver.',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  async function deleteDriver(driver) {
    setModal({
      name: 'confirmation',
      data: {
        title: `Delete driver`,
        description: `Do you really want to delete this driver?`,
      },
      action: async () => {
        setModal('');

        await axios
          .delete(`/api/driver/${driver.id}`)
          .then((res) => {
            setModal('');
            context.notification.show(
              'Driver deleted.',
              'success',
              true,
              'toast',
              'check-circle'
            );

            runAPI(page, searchQueryString, false);
          })
          .catch((err) => {
            setLoading(false);

            context.notification.show(
              'Failed to load table data',
              'error',
              true,
              'toast',
              'x-circle'
            );
          });
      },
    });
  }

  function editDriver(driver) {
    setModal({
      name: 'driver_modal',
      data: driver,
      mode: 'edit',
      action: () => runAPI(page, searchQueryString),
    });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  useEffect(() => {
    runAPI(page, '');
  }, []);

  return (
    <Animate type="pop">
      <div
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              width: '150px',
              backgroundColor: 'black',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'default',
            }}
          >
            Active
          </div>
          <div
            onClick={() => {
              window.location.href =
                '/app/company/' + company_id + '/drivers/archived';
            }}
            style={{
              backgroundColor: '#EAEAEA',
              width: '150px',
              color: '#090E3480',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'pointer',
            }}
          >
            Archived
          </div>
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <IconedButton
            size="140px"
            color="#d32425"
            textColor="white"
            icon="plus-circle"
            text="Add Driver"
            marginRight
            action={() =>
              setModal({
                name: 'driver_modal',
                action: () => runAPI(page, searchQueryString),
              })
            }
          />
        </div>
      </div>
      <Grid cols="1">
        <div className={styles.wrapper}>
          <div style={{ margin: 20 }}>
            <div style={{ marginBottom: 30 }}>
              <Search
                callback={(query) => {
                  setSearchQueryString(query);
                }}
              />
            </div>
            <Table
              loading={loading}
              data={payload && payload.data ? data : null}
              badge={{
                col: 'status',
                condition: [
                  { value: 'Active', color: 'green' },
                  { value: 'Inactive', color: 'red' },
                ],
              }}
              hide={[
                'link',
                'id',
                'front_license_link',
                'back_license_link',
                'accidents',
                'suspensions',
                'violations',
                'Date of Hire',
                'exclude_from_policy',
              ]}
              actions={{
                custom: [
                  {
                    icon: 'edit',
                    tooltip: 'Edit this driver',
                    action: (row) => {
                      editDriver(row);
                    },
                  },
                  {
                    icon: 'archive',
                    tooltip: 'Archive this driver',
                    action: (row) => {
                      archiveDriver(row.id);
                    },
                  },
                  {
                    icon: 'trash',
                    tooltip: 'Delete this driver',
                    action: (row) => {
                      deleteDriver(row);
                    },
                  },
                ],
              }}
            />
            {payload && (
              <Pagination
                pagesCount={payload.pages_count}
                active={payload.page}
                onChange={async (newPage) => {
                  setPage(newPage);
                  runAPI(newPage, searchQueryString);
                }}
              />
            )}
          </div>
        </div>
      </Grid>
    </Animate>
  );
}
